import * as React from "react";
import styled from "styled-components/native";

import { Theme } from "../../styles";

import Icon, { IconProps } from "./Icon";
import DefaultButton, {
  ButtonProps,
} from "../../components/common/PressableButton";

export const ICON_BUTTON_SIZE = Theme.spacing * 4.5;

const Button = styled(DefaultButton).attrs({ roundness: ICON_BUTTON_SIZE })`
  padding: 0;
  width: ${ICON_BUTTON_SIZE}px;
  height: ${ICON_BUTTON_SIZE}px;
  align-items: center;
`;

export interface IconButtonProps extends ButtonProps {
  name: IconProps["name"];
  background?: string;
}

function IconButton({ name, background, ...rest }: IconButtonProps) {
  return (
    <Button {...rest} background={background}>
      {(iconProps) => <Icon name={name} {...iconProps} />}
    </Button>
  );
}

export default IconButton;
